// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"39cdc7dd","537":"179bf945","615":"55646ca3","686":"2762cb8d"}[chunkId] + ".chunk.css";
};